import { render, staticRenderFns } from "./VesselCurrentAIS.vue?vue&type=template&id=772a2c70&scoped=true"
import script from "./VesselCurrentAIS.vue?vue&type=script&lang=js"
export * from "./VesselCurrentAIS.vue?vue&type=script&lang=js"
import style0 from "./VesselCurrentAIS.vue?vue&type=style&index=0&id=772a2c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772a2c70",
  null
  
)

export default component.exports